export enum StatusViewModelEnum {
  Success = 'success',
  Warning = 'warning',
  Disabled = 'disabled',
  Error = 'error',
}
